export default {
  API_ENDPOINT: 'https://josh-noteful-api.herokuapp.com'
}
